module.exports = __webpack_public_path__ + "static/media/rennie_logo_v3.6e7c31db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rennie_logo_v3.svg
// module id = 373
// module chunks = 0